export const UPDATE_EDOK_FORM_REQUEST = 'UPDATE_EDOK_FORM_REQUEST';

export const updateEdokFormRequest = ( id, updateData ) => ({
    type: UPDATE_EDOK_FORM_REQUEST,
    payload: {
        id,
        updateData
    }
});
